var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"15e292aa529f436fc89daf33abbb9bcdbaa753d5"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["gatsby@homepl"]={id:"15e292aa529f436fc89daf33abbb9bcdbaa753d5"};
      